import React, { Component, Fragment } from 'react';
import './App.scss';
import { HashRouter as Router } from "react-router-dom";
import Routes from "./components/organisms/Routes";
import Loader from './components/atoms/Loader/Loader';

class App extends Component {
  state = {
    showLoader: false
  }

  componentDidMount() {
    this.setState({
      showLoader: true
    })
    setTimeout(() => {
      this.setState({
        showLoader: false
      })
    }, 2000)
  }
  render() {
    return (
      <Fragment>
        {this.state.showLoader && <Loader />}
        {!this.state.showLoader && <Router>
          <Routes />
        </Router>}
       
      </Fragment>
    );
  }
}

export default App;
